import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,{attrs:{"color":_vm.getColor(),"outlined":"","small":""}},[(_vm.date !== '')?_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.date,'from', 'now')))]):_c('span',[_vm._v(" "+_vm._s(_vm.$t('chips_last_statement.no_statement'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }